






















































































import { Vue, Component, Prop } from "vue-property-decorator";
import { Button, SvgIcon, Tabs, TabPane } from "@brankas/web-ui";
import { EUserTypes } from "@/pagesCom/ClientInfo/index.dto";
import CompanyInfoContent from "./CompanyInfoContent.vue";
import BusinessOwnerContent from "./BusinessOwnerContent.vue";
import PersonsInChargeContent from "./PersonsInChargeContent.vue";
import SupportingDocumentsContent from "./SupportingDocumentsContent.vue";

import { ClientInfo } from "@/types";
import { COUNTRY_MOBILE_CODES, TIME_ZONES } from "@/constant";

@Component({
  components: {
    Button,
    SvgIcon,
    Tabs,
    TabPane,
    CompanyInfoContent,
    BusinessOwnerContent,
    PersonsInChargeContent,
    SupportingDocumentsContent,
  },
})
export default class ClientInfoCard extends Vue {
  @Prop({ type: Object, default: () => ({}) }) info!: ClientInfo;
  @Prop({ type: String, default: "" }) id!: string;

  countryCodes = COUNTRY_MOBILE_CODES;
  countryTimeZones = TIME_ZONES;
  showEditMenu = false;
  selectedTab = null;

  onClickOutside() {
    this.showEditMenu = false;
  }

  get isShowingBusinessOwner(): boolean {
    return this.info.userType === EUserTypes.INDIVIDUAL;
  }
}
